import { Action } from "../../../action";
import { DefaultApi } from "../../../api";
import { getCatchError } from "../../../getCatchError";
import { urls } from "../../../urls";

const setGetGameFreespin = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await DefaultApi({
                params,
                method: 'get',
                url: urls.GET_STATUS_LIST_FS_GAME
            });

            if (data.status === 'success') {
                dispatch(Action.SetGetGamesListFsAction(data.data))
            }
        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setGetGameFreespin as SetGetGameFreespin
} 